<template>
  <tela-component title="Formação de Carga">
    <carregando-overlay
      v-if="carregando"
      title="Aguarde..."
      subtitle="Buscando dados da carga"
    />
    <template v-else>
      <informar-placa-veiculo-form-carga />
      <distribuir-caixas-form-carga v-if="veiculo.dados" class="mt-2" />
    </template>

    <router-view></router-view>
  </tela-component>
</template>

<script>
import TelaComponent from "@/components/tela/TelaComponent.vue";
import { mapActions, mapMutations, mapState } from "vuex";
import InformarPlacaVeiculoFormCarga from "@/components/formacao-carga/InformarPlacaVeiculoFormCarga.vue";
import DistribuirCaixasFormCarga from "@/components/formacao-carga/DistribuirCaixasFormCarga.vue";
import CarregandoOverlay from "@/components/tela/CarregandoOverlay.vue";

export default {
  components: {
    TelaComponent,
    InformarPlacaVeiculoFormCarga,
    DistribuirCaixasFormCarga,
    CarregandoOverlay,
  },
  computed: {
    ...mapState("formacaoCarga", [
      "veiculo",
      "cargas",
      "cargaSelec",
      "configuracoes",
      "alterouPlaca",
    ]),
    ...mapState("usuario", ["usuarioLogado"]),
  },
  watch: {
    alterouPlaca: async function (value) {
      if (value) {
        this.setAltPlaca(false);
        await this.inicializarDados();
      }
    },
  },
  methods: {
    ...mapMutations("formacaoCarga", [
      "setIdCarga",
      "resetState",
      "setCarga",
      "setAltPlaca",
    ]),
    ...mapMutations("relatorios", ["setVendedor"]),
    ...mapActions("formacaoCarga", [
      "buscarVeiculo",
      "buscarCargas",
      "buscarConfiguracoes",
      "buscarTodasPlacas",
    ]),
    isMobile() {
      return this.$mq == "sm";
    },
    async inicializarDados() {
      this.carregando = true;
      this.resetState();
      await this.buscarTodasPlacas();
      await this.buscarConfiguracoes();

      this.setVendedor(
        this.usuarioLogado.codrepresentante > 0
          ? this.usuarioLogado.codrepresentante
          : 0
      );

      if (this.$route.params.id > 0) {
        this.setIdCarga(this.$route.params.id);
        await this.buscarCargas();

        if (this.cargas.dados.cargas.length > 0) {
          this.setCarga(this.cargas.dados.cargas[0]);
          this.cargaSelec.informar_placa = this.cargaSelec.placa != "";
          await this.buscarVeiculo();
        }
      } else {
        this.setIdCarga(0);
        this.setCarga({
          id: 0,
          placa: "",
          descricao: "",
          pode_editar: true,
          hash_reg: "",
          dist_caixas: [],
          informar_placa: true,
          data_hora_prog_carreg:
            this.configuracoes.dados.datas_carregamento[0].data_carreg,
          cod_vendedor: 0,
          inf_pedido: false,
          pode_add_pedido: true,
        });
      }

      this.carregando = false;
    },
  },
  data: () => ({
    carregando: true,
  }),

  async mounted() {
    await this.inicializarDados();
  },
};
</script>

<style>
</style>

    